<template>
    <view class="headers" :style="HeaderStyle.style" >
        <img :style="HeaderStyle.logoStyle" :src="HeaderStyle.logoStyle.icon" />
        <img :style="HeaderStyle.nameStyle" :src="HeaderStyle.nameStyle.icon" />
    </view>
</template>

<script setup>
    import { ref } from 'vue'
    const HeaderStyle = ref(window.globalConfig.headerStyle);

</script>

<style lang="scss" scoped>
    .headers {
        max-width: 750px;
        height: 96px;
        display: flex;
        padding-left: 12px;
        align-items: center;
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        z-index: 1000;
    }
</style>